import * as React from 'react';
import { Icons } from 'components';
import clsx from 'clsx';
import { FileUtils } from 'utils';

import './style.scss';
import { WithTranslation, withTranslation } from 'react-i18next';

export interface IFileChooserProps extends WithTranslation {
    files: File[];
    onAdd: (file: File) => void;
    onRemove: (file: File) => void;
    className?: string;
}
export interface IFileChooserState { }

class FileChooserComponent extends React.Component<IFileChooserProps, IFileChooserState> {
    private file_input_el: HTMLInputElement;
    constructor(props: IFileChooserProps) {
        super(props);

        this.renderFile = this.renderFile.bind(this);
        this.onFileChoose = this.onFileChoose.bind(this);
    }

    onFileChoose(event: React.ChangeEvent<HTMLInputElement>) {
        let input = event.currentTarget;
        let [ file ] = input.files;

        this.props.onAdd(file);
        input.value = '';
    }

    renderFile(file: File, i: number) {
        let file_extention = FileUtils.getFileExtention(file.name);
        return (
            <div key={`${file.name}_${i}`} className="file-wrapper">
                <div className={clsx('file-icon', file_extention)}>
                    {FileUtils.getFileIcon(file_extention)}
                </div>
                <div className="file-name">{file.name}</div>
                <div className="file-actions">
                    <Icons.IconGarbageBin
                        className='file-action'
                        onClick={() => {
                            this.props.onRemove(file);
                        }}
                    />
                </div>
            </div>
        );
    }

    render() {
        let { className, t } = this.props;
        return (
            <div className={clsx('file-chooser-wrapper', className)}>
                <div className="file-list-wrapper">
                    {this.props.files.map(this.renderFile)}
                </div>
                <div className="button-wrapper">
                    <label className='oms-button variant-blue'>
                        {t('Прикрепить файл')}
                        <input
                            ref={(el) => { this.file_input_el = el; }}
                            type="file"
                            onChange={this.onFileChoose}
                        />
                    </label>
                </div>

            </div>
        );
    }
}

export const FileChooser = withTranslation()(FileChooserComponent);
